import Vue from "vue";

import {
  Quasar,
  ClosePopup,
  Notify,
  QAvatar,
  QBanner,
  QBtn,
  QBtnGroup,
  QCard,
  QCardActions,
  QCardSection,
  QCheckbox,
  QChip,
  QDate,
  QDialog,
  QDrawer,
  QExpansionItem,
  QField,
  QForm,
  QHeader,
  QIcon,
  QInput,
  QItem,
  QItemLabel,
  QItemSection,
  QLayout,
  QList,
  QMenu,
  QOptionGroup,
  QPage,
  QPageContainer,
  QPopupProxy,
  QRange,
  QRating,
  QResizeObserver,
  QSelect,
  QSeparator,
  QSpace,
  QSpinner,
  QSpinnerBall,
  QSplitter,
  QStep,
  QStepper,
  QStepperNavigation,
  QTab,
  QTable,
  QTabPanel,
  QTabPanels,
  QTabs,
  QTd,
  QTh,
  QToggle,
  QToolbar,
  QToolbarTitle,
  QTooltip,
  QTr,
  QMarkupTable,
  QBadge,
} from "quasar";

Vue.use(Quasar, {
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QBtnGroup,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QCheckbox,
    QField,
    QTable,
    QTooltip,
    QTh,
    QTr,
    QTd,
    QRange,
    QCard,
    QCardSection,
    QExpansionItem,
    QSelect,
    QTabs,
    QTab,
    QTabPanels,
    QTabPanel,
    QMenu,
    QSeparator,
    QSpace,
    QForm,
    QInput,
    QBanner,
    QSpinner,
    QSpinnerBall,
    QStep,
    QStepper,
    QStepperNavigation,
    QDialog,
    QRating,
    QAvatar,
    QChip,
    QCardActions,
    QToggle,
    QOptionGroup,
    QSplitter,
    QResizeObserver,
    QDate,
    QPopupProxy,
    QMarkupTable,
    QBadge,
  },
  directives: {
    ClosePopup,
  },
  plugins: {
    Notify,
  },
  config: {
    brand: {
      primary: "#0a3b5c",
      secondary: "#90a4ae",
      accent: "#388e3c",
      dark: "#1d1d1d",
      positive: "#21BA45",
      negative: "#C10015",
      info: "#0288d1",
      warning: "#ffd54f",
    },
    notify: {},
  },
});
